import menuConfigService from "./menuConfigService";

export default {
    async isProperAccess(to, next, ...menuCodes) {
        let menuConfigs = [];

        if (to.path.startsWith('/app/') && to.name !== 'dashboard') {
            const udrId = to.path.split("/")[2];

            await menuConfigService.findAllByUserDeptRoleId(udrId)
                .then(res => {
                    if (res.data.length > 0) menuConfigs = res.data.map(value => value.menuCode)
                });

            let flag = false;
            for (let i = 0; i < menuCodes.length; i++) {
                if (menuConfigs.includes(menuCodes[i])) {
                    flag = true;
                    break;
                }
            }

            if (flag) {
                next();
            } else {
                next({
                    name: 'dashboard',
                    params: { "userDeptRoleId": udrId }
                })
            }
        } else {
            next();
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/improperAccessCheckingService.js